<div *ngIf="scenario?.modifiers" class="tab-pane fade show">
  <h5 style="display:inline-block;margin-right:12px">Modifiers</h5>
  <button class="btn btn-sm btn-primary" (click)="addModifier()">Add Modifier</button>
  <table class="table table-bordered">
    <thead>
      <tr>
        <th>Class</th>
        <th>Enabled</th>
        <th>SeqNo</th>
        <th>Edit</th>
        <th>JSON Object</th>
        <th>Delete</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let mod of scenario.modifiers; let index = index">
        <td>{{mod.class}}</td>
        <td><input type="checkbox" [(ngModel)]="mod.enabled"></td>
        <td>{{mod.seqNo}}</td>
        <td><i class="bi bi-pencil" style="color:green" (click)="editModifier(mod,index)"></i></td>
        <td>{{mod | json}}</td>
        <td><i class="bi bi-trash" style="color:orange" (click)="deleteModifier(mod,index)"></i></td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Modal showModifier -->
<div *ngIf="showModifier" #testmodal class="cpmodal">
  <div class="cpmodal-content">
    <div class="cpmodal-header">Modifier</div>
    <div *ngIf="showJsonError" style="color:brown;font-weight: bold;background-color:lightcoral;padding:20px">Failed to parse modifier text</div>
    <div class="spacer10"></div>
    <div class="row">
      <div class="col-md-6">
        <div class="inline"><sa-input-text [(text)]="modifierclass" [title]="'Class' "></sa-input-text></div>
        <div class="inline"><sa-input-number [(text)]="modifierseqno" [title]="'Sequence Number' "></sa-input-number></div>
        <div class="inline"><sa-input-text [(text)]="modifiercomponent" [title]="'Component' "></sa-input-text></div>
        <div class="inline"><sa-input-text [(text)]="modifiername" [title]="'Name'"></sa-input-text></div>
      </div>
      <div class="col-md-3">
        <b>Lessonplan Ids to be used</b>
        <div *ngFor="let l of scenario.lessonplan">
          {{l.id}} <span style="color:gray">({{l.name}})</span>
        </div>
      </div>
      <div class="col-md-3">
        <b>Available Interactivity Classes</b>
        <div>TestClass</div>
      </div>
    </div>

    <div class="spacer10"></div>
    <button class="btn btn-primary" (click)="saveModifier()">Update Modifier</button>
    <button class="btn btn-primary" style="float:right" (click)="showModifier = false;showModifierPathInstancer=false">Cancel</button>
    <div class="spacer10"></div>
    <div class="row">
      <div class="col-md-12">
        <div style="width:600px;margin-top:20px;display:inline-block"><sa-input-textarea [(text)]="modifiertext" [title]="'JSON Object'" [rows]="10"></sa-input-textarea></div>
        <button class="btn btn-info" style="margin-left:20px" (click)="saveModifierFromJsonString()">Update Modifier from JSON String</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal showModifierPathInstancer -->
<div *ngIf="showModifierPathInstancer" #testmodal class="cpmodal">
  <div class="cpmodal-content">
    <div class="cpmodal-header">Modifier Path Instancer</div>
    <div *ngIf="showJsonError" style="color:brown;font-weight: bold;background-color:lightcoral;padding:20px">Failed to parse interactivity text</div>
    <div class="spacer10"></div>
    <div class="row">
      <div class="col-md-8">
        <div class="inline"><sa-input-text [(text)]="modifierclass" [title]="'Class'"></sa-input-text></div>
        <div class="inline"><sa-input-number [(text)]="modifierseqno" [title]="'Sequence Number'"></sa-input-number></div>
        <div class="inline"><sa-input-text [(text)]="modifiercomponent" [title]="'Component'"></sa-input-text></div>
        <div class="inline"><sa-input-text [(text)]="modifiername" [title]="'Name'"></sa-input-text></div><br>
        <sa-input-text [(text)]="modifiercommands" [title]="'Commands' "></sa-input-text>
        <button class="btn btn-sm btn-outline-secondary" style="margin-top:4px" (click)="parseCommandString()">Parse</button>

        <!-- Command Preview -->
        <div *ngIf="showCommandPreview" style="margin-top:10px">
          <div *ngIf="commandParseRemainder" class="alert alert-warning" style="font-size:12px;padding:6px 10px">
            <strong>Unparsed remainder:</strong> <code>{{commandParseRemainder}}</code>
          </div>
          <table class="table table-sm table-bordered" style="font-size:12px">
            <thead style="background-color:#f8f9fa">
              <tr><th>#</th><th>Token</th><th>Meaning</th><th>Value</th></tr>
            </thead>
            <tbody>
              <tr *ngFor="let cmd of parsedCommands; let i = index">
                <td>{{i + 1}}</td>
                <td><code>{{cmd.token}}</code></td>
                <td>{{cmd.meaning}}</td>
                <td>{{cmd.value}}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="inline"><sa-input-text [(text)]="modifierForewardAxis" [title]="'Foreward Axis (+X/-X/+Z/-Z)'"></sa-input-text></div>
        <div class="inline"><sa-input-number [(text)]="modifierStepSize" [title]="'Step Size'"></sa-input-number></div>
        <div class="inline"><sa-input-number [(text)]="modifierOriginOffsetX" [title]="'Origin Offset X'"></sa-input-number></div>
        <div class="inline"><sa-input-number [(text)]="modifierOriginOffsetZ" [title]="'Origin Offset Z'"></sa-input-number></div>
        <div class="inline"><sa-input-number [(text)]="modifierRotationOffsetDeg" [title]="'Rotation Offset (deg)'"></sa-input-number></div>
        
        <!-- Commands String Explanation -->
        <div class="alert alert-info" style="margin-top: 10px; font-size: 12px;">
          <strong>Commands String Format:</strong><br>
          Example: <code>ss2.55d-90m1s22r90s23r90s23r90s23</code><br>
          <ul class="mb-0" style="padding-left: 20px;">
            <li><strong>ss2.55</strong> - sets the step size to 2.55</li>
            <li><strong>d-90</strong> - changes the marching direction by -90 degrees</li>
            <li><strong>m1</strong> - moves the mesh by 1 step</li>
            <li><strong>s22</strong> - duplicates the mesh 22 times</li>
            <li><strong>r90</strong> - rotates the mesh and marching directionby 90 degrees</li>
            <li><strong>s23</strong> - duplicates the mesh 23 times</li>
          </ul>
        </div>
      </div>
      <div class="col-md-4">
        <div style="max-width:600px;margin-top:20px"><sa-input-textarea [(text)]="modifiertext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
        <button class="btn btn-info" (click)="saveModifierFromJsonString()">Update Modifier from string</button>
      </div>
    </div>

    <div class="spacer10"></div>
    <button class="btn btn-primary" (click)="saveModifier()">Update Modifier</button>
    <button class="btn btn-primary" style="float:right" (click)="showModifierPathInstancer= false;showModifier=false">Cancel</button>
    <div class="spacer10"></div>
  </div>
</div>

<!-- Modal showModifierGrass -->
<div *ngIf="showModifierGrass" #testmodal class="cpmodal">
  <div class="cpmodal-content">
    <div class="cpmodal-header">Modifier Grass</div>
    <div *ngIf="showJsonError" style="color:brown;font-weight: bold;background-color:lightcoral;padding:20px">Failed to parse modifier text</div>
    <div class="spacer10"></div>
    <div class="row g-3">
      <div class="col-md-4">
        <div class="inline"><sa-input-text [(text)]="modifierclass" [title]="'Class'"></sa-input-text></div>
        <div class="inline"><sa-input-number [(text)]="modifierseqno" [title]="'Sequence Number'"></sa-input-number></div>
        <div class="inline"><sa-input-text [(text)]="modifiercomponent" [title]="'Component'"></sa-input-text></div>
        <div class="inline"><sa-input-text [(text)]="modifiername" [title]="'Name'"></sa-input-text></div>
      </div>
      <div class="col-md-4">
        <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Grass Parameters</div>
        <div class="inline"><sa-input-number [(text)]="modifier.nBlades" [title]="'nBlades'"></sa-input-number></div>
        <div class="inline"><sa-input-number [(text)]="modifier.radius" [title]="'radius'"></sa-input-number></div>
        <div class="inline"><sa-input-number [(text)]="modifier.xPos" [title]="'xPos'"></sa-input-number></div>
        <div class="inline"><sa-input-number [(text)]="modifier.zPos" [title]="'zPos'"></sa-input-number></div>
      </div>
      <div class="col-md-4">
        <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
        <div style="margin-top:0"><sa-input-textarea [(text)]="modifiertext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
        <button class="btn btn-info btn-sm mt-2" (click)="saveModifierFromJsonString()">Update from JSON</button>
      </div>
    </div>
    <div class="spacer10"></div>
    <button class="btn btn-primary" (click)="saveModifier()">Update Modifier</button>
    <button class="btn btn-primary" style="float:right" (click)="showModifierGrass=false; showModifier=false; showModifierPathInstancer=false">Cancel</button>
    <div class="spacer10"></div>
  </div>
</div>

<!-- Modal showModifierWater -->
<div *ngIf="showModifierWater" #testmodal class="cpmodal">
  <div class="cpmodal-content">
    <div class="cpmodal-header">Modifier Water</div>
    <div *ngIf="showJsonError" style="color:brown;font-weight: bold;background-color:lightcoral;padding:20px">Failed to parse modifier text</div>
    <div class="spacer10"></div>
    <div class="row g-3">
      <div class="col-md-4">
        <div class="inline"><sa-input-text [(text)]="modifierclass" [title]="'Class'"></sa-input-text></div>
        <div class="inline"><sa-input-number [(text)]="modifierseqno" [title]="'Sequence Number'"></sa-input-number></div>
        <div class="inline"><sa-input-text [(text)]="modifiercomponent" [title]="'Component'"></sa-input-text></div>
        <div class="inline"><sa-input-text [(text)]="modifiername" [title]="'Name'"></sa-input-text></div>
      </div>
      <div class="col-md-4">
        <div class="fw-bold small text-uppercase" style="margin-bottom:4px">Water Parameters</div>
        <div class="inline"><sa-input-text [(text)]="modifier.waterMethod" [title]="'Water Method'"></sa-input-text></div>
      </div>
      <div class="col-md-4">
        <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
        <div style="margin-top:0"><sa-input-textarea [(text)]="modifiertext" [title]="'JSON Object'" [rows]="15"></sa-input-textarea></div>
        <button class="btn btn-info btn-sm mt-2" (click)="saveModifierFromJsonString()">Update from JSON</button>
      </div>
    </div>
    <div class="spacer10"></div>
    <button class="btn btn-primary" (click)="saveModifier()">Update Modifier</button>
    <button class="btn btn-primary" style="float:right" (click)="showModifierWater=false; showModifier=false; showModifierPathInstancer=false; showModifierGrass=false">Cancel</button>
    <div class="spacer10"></div>
  </div>
</div>

<!-- Modal showModifierComponentCopy -->
<div *ngIf="showModifierComponentCopy" #testmodal class="cpmodal">
  <div class="cpmodal-content">
    <div class="cpmodal-header">Modifier Component Copy</div>
    <div *ngIf="showJsonError" style="color:brown;font-weight: bold;background-color:lightcoral;padding:20px">Failed to parse modifier text</div>
    <div class="spacer10"></div>
    <div class="row g-3">
      <div class="col-md-3">
        <div class="inline"><sa-input-text [(text)]="modifierclass" [title]="'Class'"></sa-input-text></div>
        <div class="inline"><sa-input-number [(text)]="modifierseqno" [title]="'Sequence Number'"></sa-input-number></div>
        <div class="inline"><sa-input-text [(text)]="modifiercomponent" [title]="'Component'"></sa-input-text></div>
        <div class="inline">
          <button class="btn btn-outline-info btn-sm" type="button" (click)="setCoordinates()">See Coordinates</button>
        </div>
        <div *ngIf="componentCoordinatesText" class="small" style="margin-top:4px;color:#495057;white-space:pre-line;">
          {{componentCoordinatesText}}
        </div>
        <div class="inline"><sa-input-text [(text)]="modifiername" [title]="'Name'"></sa-input-text></div>
      </div>
      <div class="col-md-9">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div class="fw-bold small text-uppercase">Component Copies</div>
          <button class="btn btn-outline-primary btn-sm" (click)="addCopy()" type="button">
            <i class="bi bi-plus"></i> Add Copy
          </button>
        </div>
        <div class="text-muted small mb-2" *ngIf="!modifier.copies || modifier.copies.length === 0">No copies defined yet</div>
        
        <!-- Scrollable container for copies -->
        <div style="max-height: 300px; overflow-y: auto; border: 1px solid #dee2e6; border-radius: 0.375rem; padding: 8px; background-color: #f8f9fa;">
          <div *ngFor="let copy of modifier.copies; let i = index; trackBy: trackByCopyIndex" class="border rounded p-2 mb-2 bg-white">
            <div class="row g-1 align-items-end">
              <div class="col-2">
                <label class="form-label small">Name</label>
                <input class="form-control form-control-sm" [(ngModel)]="modifier.copies[i].name" placeholder="Copy name" />
              </div>
              <div class="col-2">
                <label class="form-label small">X</label>
                <input type="number" class="form-control form-control-sm" [(ngModel)]="modifier.copies[i].posX" placeholder="0" />
              </div>
              <div class="col-2">
                <label class="form-label small">Y</label>
                <input type="number" class="form-control form-control-sm" [(ngModel)]="modifier.copies[i].posY" placeholder="0" />
              </div>
              <div class="col-2">
                <label class="form-label small">Z</label>
                <input type="number" class="form-control form-control-sm" [(ngModel)]="modifier.copies[i].posZ" placeholder="0" />
              </div>
              <div class="col-1">
                <label class="form-label small">RX</label>
                <input type="number" class="form-control form-control-sm" [(ngModel)]="modifier.copies[i].rotX" placeholder="0" />
              </div>
              <div class="col-1">
                <label class="form-label small">RY</label>
                <input type="number" class="form-control form-control-sm" [(ngModel)]="modifier.copies[i].rotY" placeholder="0" />
              </div>
              <div class="col-1">
                <label class="form-label small">RZ</label>
                <input type="number" class="form-control form-control-sm" [(ngModel)]="modifier.copies[i].rotZ" placeholder="0" />
              </div>
              <div class="col-1">
                <label class="form-label small">Scale</label>
                <input type="number" class="form-control form-control-sm" [(ngModel)]="modifier.copies[i].scale" placeholder="1" />
              </div>
              <div class="col-auto">
                <button class="btn btn-outline-danger btn-sm" type="button" (click)="removeCopy(i)">
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="spacer10"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="fw-bold small text-uppercase" style="margin-bottom:4px">JSON object</div>
        <div style="width:600px;margin-top:20px;display:inline-block"><sa-input-textarea [(text)]="modifiertext" [title]="'JSON Object'" [rows]="8"></sa-input-textarea></div>
        <button class="btn btn-info" style="margin-left:20px" (click)="saveModifierFromJsonString()">Update from JSON String</button>
      </div>
    </div>
    
    <div class="spacer10"></div>
    <button class="btn btn-primary" (click)="saveModifier()">Update Modifier</button>
    <button class="btn btn-primary" style="float:right" (click)="showModifierComponentCopy=false; showModifier=false; showModifierPathInstancer=false; showModifierGrass=false">Cancel</button>
    <div class="spacer10"></div>
  </div>
</div>